export default [
  {
    path: '/monitoring/outgoing-failed',
    name: 'monitoring-outgoing',
    component: () => import('@/views/monitoring/OutgoingMessages.vue'),
    meta: {
      resource: 'Outgoing',
      action: 'View',
    },
  },
  {
    path: '/monitoring/incoming-failed',
    name: 'monitoring-incoming',
    component: () => import('@/views/monitoring/IncomingMessages.vue'),
    meta: {
      resource: 'Incoming',
      action: 'View',
    },
  },
  {
    path: '/monitoring/transaction',
    name: 'monitoring-transaction',
    component: () => import('@/views/monitoring/TarnsactionLog.vue'),
    meta: {
      resource: 'Transaction',
      action: 'View',
    },
  },
  {
    path: '/monitoring/lastPaid',
    name: 'lastPaid-index',
    component: () => import('@/views/monitoring/LastPaid.vue'),
    meta: {
      resource: 'LastPaid',
      action: 'View',
    },
  },
]
